var s4 = require('./s4');

module.exports = function generateUUID() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
};



// WEBPACK FOOTER //
// ./src/data/uuid.js